/* Cozy Knockers page: gallery, colour swatches, colour cards, sticky add to cart */
(function () {
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function initHero(root) {
    if (!root || root.dataset.hwReady) return;
    root.dataset.hwReady = '1';

    var track = root.querySelector('[data-ck-track]');
    var thumbs = root.querySelectorAll('[data-ck-thumb]');
    var count = root.querySelector('[data-ck-count]');
    var slides = track ? track.querySelectorAll('[data-ck-slide]') : [];
    var current = 0, raf;

    var setActive = function (i) {
      current = i;
      if (count) count.textContent = i + 1;
      each(thumbs, function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    };
    var goTo = function (i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    };

    if (track) {
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      each(thumbs, function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ck-thumb'), 10)); });
      });
    }

    var form = root.querySelector('[data-ck-form]');
    var atc = root.querySelector('[data-ck-atc]');
    var atcText = root.querySelector('[data-ck-atc-text]');
    var now = root.querySelector('[data-ck-now]');
    var was = root.querySelector('[data-ck-was]');
    var save = root.querySelector('[data-ck-save]');
    var colourName = root.querySelector('[data-ck-colour-name]');
    var meta = root.querySelector('[data-ck-sticky-meta]');
    var label = root.getAttribute('data-atc-label') || 'Add to cart';

    var apply = function (r, scrollGallery) {
      each(form.querySelectorAll('.ck-bundle'), function (s) { s.classList.toggle('is-selected', s.contains(r)); });
      var price = r.getAttribute('data-price');
      var available = r.getAttribute('data-available') === 'true';
      if (now) now.textContent = price;
      if (was && save) {
        var w = r.getAttribute('data-was');
        if (w) {
          was.innerHTML = '<span class="ck-visually-hidden">Regular price</span>' + w;
          save.textContent = 'Save ' + r.getAttribute('data-save') + '%';
          was.hidden = false; save.hidden = false;
        } else { was.hidden = true; save.hidden = true; }
      }
      if (colourName) colourName.textContent = r.getAttribute('data-title');
      if (atcText) atcText.textContent = available ? label + ' · ' + price : 'Sold out';
      if (atc) atc.disabled = !available;
      if (meta) meta.textContent = r.getAttribute('data-title') + ' · ' + price;
      if (scrollGallery !== false) goTo(parseInt(r.getAttribute('data-media'), 10) || 0);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', r.value);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (err) {}
    };

    if (form) {
      form.addEventListener('change', function (e) {
        var r = e.target;
        if (r && r.name === 'id') apply(r);
      });
      form.addEventListener('submit', function () { if (atc) atc.classList.add('is-loading'); });
      window.addEventListener('pageshow', function () { if (atc) atc.classList.remove('is-loading'); });

      // Show the selected colour's photo on load (e.g. ?variant= links)
      var checked = form.querySelector('input[name="id"]:checked');
      if (checked && checked.getAttribute('data-media') && checked.getAttribute('data-media') !== '0') {
        requestAnimationFrame(function () { goTo(parseInt(checked.getAttribute('data-media'), 10), false); });
      }

      // Colour cards further down the page pick the colour here
      each(document.querySelectorAll('[data-ck-pick]'), function (a) {
        a.addEventListener('click', function () {
          var r = form.querySelector('input[name="id"][value="' + a.getAttribute('data-ck-pick') + '"]');
          if (r && !r.disabled) { r.checked = true; apply(r); }
        });
      });
    }

    var sticky = root.querySelector('[data-ck-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var btn = sticky.querySelector('[data-ck-sticky-btn]');
      var pastAtc = false, closerVisible = false;
      var update = function () {
        var show = pastAtc && !closerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (btn) btn.tabIndex = show ? 0 : -1;
        document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        pastAtc = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }).observe(atc);
      var closer = document.querySelector('[data-ck-closer]');
      if (closer) {
        new IntersectionObserver(function (entries) {
          closerVisible = entries[0].isIntersecting;
          update();
        }).observe(closer);
      }
      if (btn) {
        btn.addEventListener('click', function () {
          if (!form || atc.disabled) return;
          if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
        });
      }
    }
  }

  function initAll(scope) { each(scope.querySelectorAll('[data-ck-hero]'), initHero); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
